"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("../icon-base"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FaUser = function FaUser(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M1280 1399q0 109-62.5 187t-150.5 78H213q-88 0-150.5-78T0 1399q0-85 8.5-160.5t31.5-152 58.5-131 94-89T327 832q131 128 313 128t313-128q76 0 134.5 34.5t94 89 58.5 131 31.5 152 8.5 160.5zm-256-887q0 159-112.5 271.5T640 896 368.5 783.5 256 512t112.5-271.5T640 128t271.5 112.5T1024 512z"
  })));
};
FaUser.defaultProps = {
  viewBox: '0 0 1354.811 1896.083',
  height: '1em',
  width: '0.7145em'
};
FaUser.displayName = 'FaUser';
var _default = FaUser;
exports.default = _default;